import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormControl, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { AppService } from "src/app/core/services/app.service";
import { FormValidationService } from "src/app/core/services/form-validation.service";
import { FocusPayApplication } from "src/app/shared/models/FocusPay/FocusPayApplication.item";

@Component({
	selector: "app-application-restaurant-information",
	templateUrl: "./application-restaurant-information.component.html",
	styleUrls: ["../../focuspay.style.scss"],
})
export class ApplicationRestaurantInformationComponent implements OnInit {
	@Input() application: FocusPayApplication;
	@Input() readOnly: boolean;
	@Output() applicationEmitter = new EventEmitter<FocusPayApplication>();

	@Output() displayModal = new EventEmitter<string>();
	@Output() inputActionEmitter = new EventEmitter<any>();
	@Output() sectionCompleteEmitter = new EventEmitter<any>();
	sectionStatus: Subject<any> = new Subject<any>();

	merchantAddressStreetControl: UntypedFormControl;
	merchantAddressCityControl: UntypedFormControl;
	merchantAddressStateControl: UntypedFormControl;
	merchantAddressPostalCodeControl: UntypedFormControl;
	merchantNameControl: UntypedFormControl;
	merchantPhoneControl: UntypedFormControl;
	merchantEmailControl: UntypedFormControl;
	merchantWebsiteControl: UntypedFormControl;

	sectionComplete: boolean = false;

	constructor(public app: AppService, private validatorService: FormValidationService) {}

	ngOnInit(): void {
		this.merchantAddressStreetControl = new UntypedFormControl({ value: this.application.merchantAddress.street, disabled: this.readOnly }, [Validators.required]);
		this.merchantAddressCityControl = new UntypedFormControl({ value: this.application.merchantAddress.city, disabled: this.readOnly }, [Validators.required]);
		this.merchantAddressStateControl = new UntypedFormControl({ value: this.application.merchantAddress.state, disabled: this.readOnly }, [Validators.required]);
		this.merchantAddressPostalCodeControl = new UntypedFormControl({ value: this.application.merchantAddress.postalCode, disabled: this.readOnly }, [
			Validators.required,
		]);
		this.merchantNameControl = new UntypedFormControl({ value: this.application.accountNameDba, disabled: this.readOnly }, [Validators.required]);
		this.merchantPhoneControl = new UntypedFormControl({ value: this.application.merchantPhone, disabled: this.readOnly }, [
			Validators.required,
			this.validatorService.phoneValueValidate(),
		]);
		this.merchantEmailControl = new UntypedFormControl({ value: this.application.merchantEmail, disabled: this.readOnly }, [
			Validators.required,
			Validators.email,
		]);
		this.merchantWebsiteControl = new UntypedFormControl({ value: this.application.website, disabled: this.readOnly }, []);
		setTimeout(() => {
			this.inputAction();
		}, 500);
	}

	inputAction(inputEvent?) {
		inputEvent && this.inputActionEmitter.emit(inputEvent);
		this.sectionCompleteEmitter.emit({
			section: "restaurant",
			complete: false,
		});

		this.sectionStatus.next({
			section: "restaurant",
			complete: false,
		});
		this.sectionComplete = false;
		if (!this.merchantAddressStreetControl.value || this.merchantAddressStreetControl.errors) return;
		if (!this.merchantAddressCityControl.value || this.merchantAddressCityControl.errors) return;

		if (!this.merchantAddressStateControl.value || this.merchantAddressStateControl.errors) return;

		if (!this.merchantAddressPostalCodeControl.value || this.merchantAddressPostalCodeControl.errors) return;
		if (!this.merchantNameControl.value || this.merchantNameControl.errors) return;
		if (!this.merchantPhoneControl.value || this.merchantPhoneControl.errors) return;
		if (!this.merchantEmailControl.value || this.merchantEmailControl.errors) return;
		this.sectionComplete = true;
		this.sectionCompleteEmitter.emit({
			section: "restaurant",
			complete: true,
		});
		this.sectionStatus.next({
			section: "restaurant",
			complete: true,
		});
	}
}
